<template>
	<div
		class="blain-form tooltip,
		tooltip-validation show-labels"
		@keydown.enter="handleSubmit"
	>
		<div class="form-group zip-input">
			<label v-if="showLabel" for="stockStatusZip">
				{{ labelText }}
			</label>
			<tool-tip
				v-if="error"
				:floating-tip="isMobile"
				:show="error != null"
				:text="error"
				width="180px"
				:position="errorPosition"
			/>
			<div class="input-btn-group flex flex-stretch">
				<input
					name="stockStatusZip"
					:placeholder="placeholder"
					:class="`form-control zipfield tooltipstered ${validationIcon} ${inputClass}`"
					v-model="value"
					v-focus
					type="number"
					@input="inputHandler"
				/>
				<button
					v-show="!loading"
					:disabled="disabled"
					:class="`inline-input-btn ${btnClass}`"
					@click.stop="handleSubmit"
				>
					{{ buttonLabel }}
					<i v-if="btnIcon" :class="`fa fa-${btnIcon}`" aria-hidden="true"></i>
				</button>
				<button v-show="loading" class="inline-input-btn">
					<i class="fa fa-spinner fa-spin"></i>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import focus from '../../directives/focus';
import ToolTip from '../../components/ToolTip.vue';

export default {
	name: "ZipInput",
	props: {
		btnClass: {
			type: String,
			default: ''
		},
		btnIcon: String,
		buttonLabel: String,
		error: String,
		errorPosition: {
			type: String,
			default: 'top'
		},
		labelText: String,
		loading: Boolean,
		maxLength: {
			type: Number,
			default: 5
		},
		placeholder: String,
		inputClass: {
			type: String,
			default: ''
		},
		initValue: [Number, String],
		disabled: {
			type: Boolean,
			default: false
		},
	},
	components: {
		ToolTip,
	},
	directives: {
		'focus': focus
	},
	computed: {
		isMobile() {
			return this.$mq === 'pdp-mobile';
		},
		errorShow() {
			return this.error ? true : false;
		},
		validationIcon() {
			if (this.untouched) return '';
			return this.value && this.value.length === this.maxLength && !this.errorShow
				? 'valid'
				: 'error';
		},
		showLabel() {
			return this.labelText ? true : false;
		}
	},
	data() {
		return {
			untouched: true,
			value: this.initValue,
		};
	},
	methods: {
		inputHandler(event) {
			if (
				event.target.value < 0
					|| event.data === '-'
					|| event.data === '+'
					|| event.data === '.'
			) {
				const newVal = this.value.replace(event.data, '');
				event.target.value = this.value = newVal;
			}
			if (event.target.value.length >= this.maxLength) {
				const prevValue = event.target.value.toString().slice(0, this.maxLength);
				event.target.value = this.value = prevValue;
				this.$emit('clearError');
			}
		},
		handleSubmit() {
			this.$emit('submit', this.value);
			this.untouched = false;
		}
	},
	watch: {
		initValue(newVal, oldVal) {
			if (newVal !== oldVal) this.value = newVal;
		}
	}
};
</script>

<style lang="less" scoped>
@import "../../../less/_mixins.less";
.zip-input {
	margin-bottom: 0;
	min-width: 160px;
	max-width: 180px;
	.dark-blue-rounded-square {
		background-color: #014A77;
		border: 1px solid #014A77;
		border-radius: 0 4px 4px 0;
		text-align: center;
		padding: 0 17px;
		&:hover {
			background: #0d6398;
		}
		.fa-chevron-right {
			color: #FFFFFF;
			font-size: 14px;
		}
	}
}
	.blain-form .form-control {
		font-size: 15px;
		height: auto;
		line-height: 1;
		padding: 8px 12px;
	}
	.inline-input-btn {
		font-size: 15px!important;
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
	}
.zipfield {
	border: 1px solid #fff;
	margin-right: 3px;
}
.border-grey {
	border: 1px solid #ccc;
}
@media screen and (max-width: @tablet) {
	.blain-form .form-control {
		font-size: 14px;
	}
}
@media screen and (max-width: @mobile) {
	.blain-form .form-control {
		font-size: 12px;
		height: auto;
		line-height: 1;
		padding: 5px 8px;
	}
	.inline-input-btn {
		font-size: 12px!important;
	}
}
@media screen and (max-width: @mobile-small) {
	.zip-input {
		min-width: 120px;
		max-width: 140px;
	}
}
</style>
